import styled, { css } from 'styled-components';
import ArticleIcon from '@/public/images/ackodrive/articles.svg';
import CarReviews from '@/public/images/ackodrive/carReviews.svg';
import StoriesNews from '@/public/images/ackodrive/storiesNews.svg';
import UpArrow from '@/public/images/ackodrive/chevron_up.svg';
import DownArrow from '@/public/images/ackodrive/chevron_down.svg';
import ServiceCenterIcon from '@/public/images/ackodrive/Car_Service.svg';

export const BurgerMenuIconWrapper = styled.div<{ customMargin: any }>`
    margin: ${(props) => props.customMargin || '0'};
`;

export const StyledArticlesIcon = styled(ArticleIcon)`
    width: 22px;
    height: 22px;
`;

export const StyledCarReviews = styled(CarReviews)`
    width: 22px;
    height: 22px;
`;

export const StyledStoriesNews = styled(StoriesNews)`
    width: 22px;
    height: 22px;
`;

export const BrandWidgetLink = styled.a<{ isMobile?: boolean }>`
    text-decoration: none;
    ${(props) =>
        props.isMobile
            ? `top: 150px;
    z-index: 1;
    min-width: 160px;`
            : `top: 150px;
    z-index: 1;
    min-width: 160px;`}
`;

export const BrandWidgetWrapper = styled.li<{ isMobile?: boolean }>`
    text-decoration: none;
    position: relative;
    display: flex;
    padding: 5px;
    margin: 5px;
    ${(props) =>
        props.isMobile
            ? `
    justify-content: flex-start;
    align-items: center;
    `
            : `
    align-items: center;
    background: #FFFFFF;
    `}
`;
export const StyledWidgetBrandImage = styled.img<{ isMobile?: boolean }>`
    width: 40px;
    height: 25px;
    left: -8px;
    top: 2px;
    object-fit: contain;
    object-position: center;
    margin-right: 10px;
`;

export const BrandText = styled.a<{ isMobile?: any }>`
    text-decoration: none;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    ${(props) =>
        props.isMobile
            ? `
    color: #5B5675;
  `
            : `
    color: #5B5675;
  `}
`;

export const StyledWidgetImage = (icon: any) => styled(icon)<{ extraPad: any }>`
    width: 40px;
    margin-right: 10px;
    object-fit: contain;
    object-position: center;
    ${(props) => props.extraPad && `padding: 0 2px;`}
`;

export const SubMenuWrapper = styled.div<{ isMobile?: boolean }>`
    ${(props) =>
        props.isMobile
            ? `z-index: 1;
    background: #FFFFFF;`
            : `z-index: 100;
    min-width: 250px;
    background: #FFFFFF;
    float: left;
    box-shadow: 0px 6px 12px rgb(54 53 76 / 8%);
    min-height: 61.5px;
    position: relative;
    border-left: 1px solid #E0E0E8;
    border-right: 1px solid #E0E0E8;
    :last-of-type {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      border-bottom: 1px solid #E0E0E8;
    }
    `}
`;

export const PopularBrandWrapper = styled(SubMenuWrapper)<{
    isMobile?: boolean;
}>`
    &::before {
        ${(props) =>
            !props.isMobile &&
            `content:"";
      position: absolute;
      right: 200px;
      top: -10px;
      border-style: solid;
      z-index: 1;
      border-color: rgba(12, 245, 167, 0);
      border-bottom-color: #36354C;
      border-width: 4.5px;`}
    }
    &::after {
        ${(props) =>
            !props.isMobile &&
            `content:"";
      position: absolute;
      right: 201px;
      top: -7px;
      border-style: solid;
      border-color: transparent;
      border-bottom-color: #FFFFFF;
      border-width: 3.5px;
      z-index:2;`}
    }
    ${(props) =>
        !props.isMobile &&
        `
    border: 1px solid #36354c;
    border-color: #36354c #ffffff #ffffff #ffffff;
  `}
`;

export const BrandPlaceholderWidgets = styled.ul<{ isMobile?: boolean }>`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    margin: 5px;
    padding: 5px;
    ${(props) => props.isMobile && `padding-left: 15px;`}
`;
export const PopularBrand = styled.div<{ isMobile?: boolean }>`
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    ${(props) =>
        props.isMobile
            ? css`
                  padding: 20px 0px 0px 0px;
              `
            : css`
                  height: 44px;
                  padding: 11px;
                  margin-top: 7px;
                  :hover {
                      background: #f8f7fc;
                  }
              `}
`;

export const NavBarWrapper = styled.div`
    display: flex;
    align-items: center;
`;
export const NavBarWrapperForNewCars = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    position: relative;
`;

export const NavBarText = styled.a<{ isMobile?: any; marginLeft?: any }>`
    ${(props) =>
        props.isMobile
            ? `
      color: #5B5675;
      font-weight: 600;
      margin-left: 8px;
    `
            : `
    color: #5920c5;
    font-weight: 500;
    `}

    margin-left: ${(props) =>
        props.isMobile && props.marginLeft && `${props.marginLeft}`};

    font-family: Inter;
    font-size: 16px;
    text-decoration: none;
`;

export const NavBarSubText = styled.a<{ isMobile?: any }>`
    ${(props) =>
        props.isMobile
            ? `
      color: #36354C;
      margin-left: 12px;
      padding-left: 15px;
    `
            : `
      color: #040222;
    `}
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-decoration: none;
`;

export const StyledUpArrow = styled(UpArrow)`
    width: 1.5rem;
    cursor: pointer;
    justify-self: end;
    margin-left: auto;
`;

export const StyledDownArrow = styled(DownArrow)`
    width: 1.5rem;
    cursor: pointer;
    justify-self: end;
    margin-left: auto;
`;
export const NewCarsWrapper = styled.div<{
    isExpanded: boolean;
    isMobile: boolean;
}>`
    display: flex;
    align-items: stretch;
    ${(props) =>
        props.isExpanded &&
        props.isMobile &&
        css`
            background: #f8f7fc;
            margin-left: -16px;
            padding-left: 16px;
            margin-right: -16px;
            padding-right: 16px;
            padding-top: 12px;
            margin-top: -12px;
            padding-bottom: 12px;
        `}
`;

export const NewCarsDropDownWrapper = styled.div<{ isMobile?: boolean }>`
    ${(props) =>
        !props.isMobile &&
        css`
            position: absolute;
            top: 100%;
            z-index: 100;
            padding-top: 15px;
            max-height: 600px;
            overflow-y: scroll;
            box-shadow: 0px 6px 12px rgba(54, 53, 76, 0.08);
        `}
`;

export const EVWrapper = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const EVLabel = styled.div<{ isMobile: any }>`
    align-items: center;
    padding: 2px 6px;
    border-radius: 25px;
    background: linear-gradient(90deg, #de6d2e -7.76%, #e157d4 113.79%);
    font-weight: bold;
    font-size: 8px;
    line-height: 10px;
    text-align: center;
    color: #ffffff;

    ${(props) => (props.isMobile ? `margin-left: 8px;` : `margin-left: 3px;`)}
`;

export const HotDealWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledServiceCenter = styled(ServiceCenterIcon)<{
    isMobile: boolean;
}>`
    width: auto;
    height: auto;

    ${(props) =>
        !props.isMobile &&
        `
      margin-right: 2px;
      width: 24px;
      height: 24px;
  `}
`;

export const StyledMenu = styled.nav`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: #ffffff;
    min-height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    min-width: 80%;
`;

export const HeaderWrapper = styled.div<{ newLogo: boolean }>`
    background-color: ${(props) => (props.newLogo ? '#010101' : '#7c47e1')};
    display: flex;
    padding: 20px 16px;
    justify-content: space-between;
    align-items: center;
`;

export const LogoWrapper = styled.div<{ isMobile: any }>`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    ${(props) => !props.isMobile && `margin-right: 45px;`}
`;

export const NavHeader = styled.div<{ isMobile: any }>`
    &,
    & > a {
        text-decoration: none;
        color: #4f34d2;
    }
    font-weight: bold;
    cursor: pointer;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    ${(props) =>
        props.isMobile
            ? `border-bottom: 1px solid #E7E7F0;
    padding: 20px 0;
    margin: 0 16px;`
            : `margin-right: 40px;`}
`;
